
<style>
.card-grid-operators {
  margin: 32px !important;
}
</style>

<template>
  <div>
    <v-card class="card-grid-operators">
      <div>
        <grid
          newLabel="Aggiungi"
          :headers="headers"
          :CanCreate="true"
          title="Operators"
          controller="GridElement/"
          readAll="GetOperators"
          create="Create"
          edit="Create"
          :refresh="refresh"
          :disableDelete="true"
          :hideColumns="['Id']"
        >
          <template v-slot:default="child">
            <li @click="confirmDeleteOperator(child.child.data.name.Id)">
              <i class="fas fa-trash"></i>
              <span>&nbsp; Delete</span>
            </li>
          </template>
        </grid>
      </div>
    </v-card>
    <v-dialog
      v-model="dialogDelete"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline">L'operatore selezionato ha associate {{mappingsNumber}} mappature, procedere con l'eliminazione?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            dark
            color="#5c6366"
            @click="dialogDelete = false;"
          >NO</v-btn>
          <v-btn
            dark
            color="red darken-1"
            @click="dialogDelete = false;deleteOperator(currentOperator)"
          >SI</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import grid from "../../components/gridComponent.vue";
import operatorsApi from "../../apiLogisticsTool/operatorsApi.js";
//nome api
//GetOperators

export default {
  components: {
    grid
  },

  data() {
    return {
      //headers: [ h1, "Company Code" , "Email", "Nome", "Cognome"]
      //headers: []
      headers: [
        { text: "Company Code", value: "CompanyCode" },
        { text: "Email", value: "Mail" },
        { text: "Name", value: "Name" },
        { text: "Surname", value: "Surname" }
      ],
      currentOperator: 0,
      mappingsNumber: 0,
      dialogDelete: false,
      refresh: false
    };
  },
  methods: {
    confirmDeleteOperator(id) {
      operatorsApi.MappingsNumber(id).then(resp => {
        this.mappingsNumber = resp.data;
        this.currentOperator = id;
        this.dialogDelete = true;
      });
    },
    deleteOperator(id) {
      operatorsApi.Delete(id).then(() => {
        this.refresh = !this.refresh;
      });
    }
  }
};
</script>
